import VAlert from '.'
import VAlertList from './VAlertList.vue'

export default {
  install(Vue) {
    Vue.prototype.$alert = VAlert
    Vue.component(VAlertList.name, VAlertList)
  }
}
